import React from 'react'
import firebase from 'firebase/app'
import 'firebase/auth'
import { Form, Input, notification } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { LoginPage, Container, LoginButton, ForgotPassword } from './styles'

function Reset() {

    const openNotificationWithIcon = (type, title, description) => {
      notification[type]({
        message: title,
        description: description,
      });
    };

    const resetPassword = (data) => {
      firebase.auth().sendPasswordResetEmail(data.email)
      .then(()=>{
        openNotificationWithIcon('success', "Success", "Please check your email for the reset password link and follow the instructions.")
      })
      .catch((error)=>{
        openNotificationWithIcon('error', "Error", error.message)
      });
    }
      
    return (
        <LoginPage>
            <Container>
              <h2>Reset Password</h2>
              <Form
                  layout="vertical"
                  name="reset"
                  onFinish={resetPassword}
                  size='large'
                >
                  <Form.Item
                    name="email"
                    label="Please enter your email address"
                    rules={[{ required: true, message: 'Please input your email!' }]}
                  >
                    <Input type="email" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Email"/>
                  </Form.Item>
                  <Form.Item>
                    <LoginButton type="primary" htmlType="submit">
                      Submit
                    </LoginButton>
                  </Form.Item>
                  <Form.Item>
                    <ForgotPassword href="/login">
                      Go Back
                    </ForgotPassword>
                  </Form.Item>
              </Form>
            </Container>
        </LoginPage>
    )
}

export default Reset